import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ManageContentIndices = ({ location }) => {
  const [contentIndexTypes, setContentIndexTypes] = useState([]);
  const [message, setMessage] = useState("");
  const {token,userMetadata}=useAuth()
  const history = useHistory();
  let parms = new URLSearchParams(location.search);

  const [state, setState] = useState({
    contentIndexId: parseInt(parms.get("id")),
    contentId: 0,
    contentIndexTypeId: 0,
    contentIndexName: "",
    contentIndexDescr: "",
    securityContextId: 0,
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);
  function handleSave(event) {
    console.log("handling save 1");

    event.preventDefault();
    console.log("handling save");

    var url = `${globalConfig.apiDatahubUrl}/content-indices/${state.contentIndexId}`;

    axios
      .patch(url, state, apiHeader(token))
      .then((response) => {
        console.log("response.data");
        console.log(response.status + ":" + response.data.contentInputSourceId);

        if (response.status === 200) {
          setMessage("Success");
          setInterval(() => {
            window.location.reload();
          }, 1000);
        } else {
          setMessage("Failed");
        }
        console.log(message);
        event.preventDefault();
      })
      .catch((err) => {
        console.log("error - " + err);
      });
    console.log("message info - " + message);
  }
  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-index-types`,
        apiHeader(token)
      )
      .then((res) => {
        const contentIndexTypes = res.data;
        console.log(contentIndexTypes);
        setContentIndexTypes(contentIndexTypes);
      });

    console.log("handleOnLoad() - loading id = " + state.contentIndexId);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-indices/${state.contentIndexId}`,
        apiHeader(token)
      )
      .then((res) => {
        const contentType = res.data;
        console.log("contentType");
        console.log(contentType);
        setState(contentType);
        console.log("state");
        console.log(state);
      });
  };

  function onDelete() {
    let deleteID = state.contentIndexId;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-indices/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        history.goBack();
      })
      .catch((err) => console.log("Err delete:" + err));
  }
  return (
    <form>
      <div className="container-fluid">
      <button
          type="button"
          className="btn btn btn-outline-secondary mt-2 mb-3"
          onClick={() => history.goBack()}
        >
          Go Back
        </button>
        <h4>Manage Content Indices</h4>
        <hr />
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content Object Name">
            Content Object Name
          </label>
          <input
            readOnly={true}
            id="content_id"
            className="form-control input-xlarge col-sm-8"
            value="#{ombUserProjectsForm.selectedContent._content_name}"
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Choose Index">
            Choose Index
          </label>
          <select
            onchange="submit()"
            id="contentIndices"
            value="#{contentIndexForm.currentContentIndex.contentIndexId}"
            className="form-control col-sm-8"
            valueChangeListener="#{contentIndexForm.get}"
          >
            <option value="#{ombUserProjectsForm.selectedContent.contentIndexSelectList}" />
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Index Type">
            Index Type
          </label>
          <select
            id="contentIndexTypeId"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexTypeId}
            onChange={handleChange}
          >
            {/* <option value={state.contentIndexTypeId} onChange ={handleChange} className="form-control input-xlarge col-sm-8" /> */}

            <option>Select Index Type</option>
            {contentIndexTypes.map(
              ({ contentIndexTypeName, contentIndexTypeId }) => (
                <option key={contentIndexTypeId} value={contentIndexTypeId}>
                  {contentIndexTypeName}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Index Object">
            Index Object
          </label>
          <input
            id="contentIndexName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Description">
            Description
          </label>
          <textarea
            id="contentIndexDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentIndexDescr}
            onChange={handleChange}
          />
        </div>
        <hr />
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Last Updated By #{ombUserSession.getUserNameForId(contentTemplateForm.currentContentTemplate.lastUpdateUser)} on "
          >
            Last Updated By
          </label>
          <input
            className="form-control col-sm-1"
            readonly="readonly"
            value={state.lastUpdateUser}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="#{contentTemplateForm.currentContentTemplate.lastUpdateDate}"
          >
            Last Update Date
          </label>
          <input
            className="form-control col-sm-8"
            readonly="readonly"
            value={state.lastUpdateDate.slice(0, 16)}
            type="datetime-local"
          />
        </div>
        <hr />
        <button
          className="btn btn-danger"
          value="Delete"
          onClick={onDelete}
        >
          Delete
        </button>
        {/* <button
          className="btn btn-primary"
          value="Clear"
          actionListener="#{contentIndexForm.clear}"
        >
          Clear
        </button> */}
        &nbsp;

        <button className="btn btn-success" value="Save" onClick={handleSave}>
          {" "}
          Save
        </button>
        &nbsp;

      </div>
    </form>
  );
};

export default ManageContentIndices;
